import { RouteObject } from 'react-router-dom';
import ErrorPage, { Page404 } from 'src/error-page';
import availabilityRoutes from './availability/routes';
import notificationsRoutes from '../notifications/routes';
import { FaqPageType } from '../faq/types';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

const PersonLayoutComponent = lazyConReintento(() => import('./layout/layout'));
const PersonProfileView = lazyConReintento(() => import('./my-profile'));
const PersonAccountConfig = lazyConReintento(() => import('./account-config'));
const FeedbackView = lazyConReintento(() => import('./feedback'));
const IncomeView = lazyConReintento(() => import('./income'));
const FaqPage = lazyConReintento(() => import('../faq/faq-page'));
const DashboardPerson = lazyConReintento(() => import('./dashboard'));

const personProfileRoutes: RouteObject[] = [
  {
    path: '/services',
    element: diferida(<PersonLayoutComponent />),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Page404 />
      },
      {
        path: 'dashboard',
        element: diferida(<DashboardPerson />)
      },
      {
        path: 'my-profile',
        element: diferida(<PersonProfileView />)
      },
      {
        path: 'account-config',
        element: diferida(<PersonAccountConfig />)
      },
      ...availabilityRoutes,
      {
        path: 'income',
        element: diferida(<IncomeView />)
      },
      {
        path: 'feedback',
        element: diferida(<FeedbackView />)
      },
      ...notificationsRoutes,
      {
        path: 'faq',
        element: diferida(<FaqPage type={FaqPageType.Person} />)
      },
      {
        path: '*',
        element: <Page404 />
      }
    ]
  }
];

export default personProfileRoutes;
